import { Drawer } from "antd"
import { CloseIcon } from "icons"
import styles from "./index.module.css"
import PropTypes from "prop-types"

/**
 * The app's bottom sheet: every modal that becomes a drawer on mobile renders through here.
 *
 * `hasHandle` adds the grab pill above the header, `footer` pins actions below the scrolling
 * body, and `className` reaches the antd root so a sheet can adjust its own padding. All three
 * are opt-in, so drawers that do not pass them look exactly as before.
 */
const CustomDrawer = ({ open, setOpen, title, hasHandle = false, footer, className = "", destroyOnClose = false, children }) => {
  const onCloseDrawer = () => {
    if (open) setOpen(false)
  }
  return (
    <Drawer
      className={`${styles.drawerWrapper} ${hasHandle ? styles.withHandle : ""} ${className}`}
      title={title}
      placement="bottom"
      closable={false}
      onClose={onCloseDrawer}
      open={open}
      footer={footer}
      destroyOnClose={destroyOnClose}
      extra={<CloseIcon width={20} height={20} onClick={onCloseDrawer} className="cursor-pointer" />}
    >
      {children}
    </Drawer>
  )
}

CustomDrawer.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  title: PropTypes.string,
  /** Draws the grab pill a bottom sheet is dragged by, above the header. */
  hasHandle: PropTypes.bool,
  /** Pinned below the scrolling body — use for a sheet's primary actions. */
  footer: PropTypes.node,
  className: PropTypes.string,
  destroyOnClose: PropTypes.bool,
  children: PropTypes.node
}

export default CustomDrawer
